// const slideDown = (element) =>
//     (element.style.height = `${element.scrollHeight}px`);
// const slideDownItems = document.querySelectorAll(".js-slideDown");

// slideDownItems.forEach((item) => {
//     item.addEventListener("click", function () {
//         slideDown(document.querySelector(this.getAttribute("href")));
//     });
// });

const toggleSection = (element) => {
    if (element.classList.contains("active")) {
        element.classList.remove("active");
        element.style.height = "0";
    } else {
        element.classList.add("active");
        element.style.height = `${element.scrollHeight}px`;
    }
};

const slideDownItems = document.querySelectorAll(".js-slideDown");
slideDownItems.forEach((item) => {
    item.addEventListener("click", function (event) {
        event.preventDefault();
        const target = document.querySelector(this.getAttribute("href"));
        toggleSection(target);

        // if (target.classList.contains("active")) {
            target.scrollIntoView({ behavior: "smooth" });
        // }
    });
});
